import React from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import styles from './index.css';
import AsideBox from '../components/asideBox/';
import ToTop from '../components/toTop/';
import errorBoundary from '@ifeng-fe/errorBoundary';
import HeaderNav from '@ifeng-fe/container_channel/common/client/winter/components/header';
import BodyContainer from './bodyContainer/';
import Footer from '@ifeng-fe/container_channel/common/client/winter/components/footer/';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const {
            content: { initNewsData, footer, nav },
        } = this.props;

        const bodyData = { initNewsData };

        console.log(bodyData);

        return (
            <div className={styles.mainBody}>
                <HeaderNav limit={18} content={nav} />
                <BodyContainer content={bodyData} />
                <div className={styles.footerContainer}>
                    <Chip id="20012" type="struct" title="底部公用版权" groupName="底部" content={footer}>
                        <Footer />
                    </Chip>
                </div>
                <AsideBox />
                <ToTop />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
